<div class="body">

    <div class="preview" (click)="detailsExpanded = !detailsExpanded">

        <div class="name">
            <span>{{item.itemname}}</span>
            <span class="spacer"></span>
            <span *ngIf="item.itemcontract && (selectedContract !== item.itemcontract)" class="contract-changed-hint">
                <span class="text">
                    Der Vertrag wurde verändert
                </span>
                <mat-icon matTooltip="Das Ändern des Vertrags überschreibt beim Ausführen der Aktion den aktuellen Wert des Vorgangsartikels">
                    help
                </mat-icon>
            </span>

        </div>

    </div>

    <div class="details" @slideIn *ngIf="detailsExpanded">

        <ng-container *ngFor="let contract of contracts">

            <div class="contract-wrapper" (click)="selectedContract = contract.contractid">
                <mat-checkbox [checked]="contract.contractid === selectedContract" (click)="$event.preventDefault()"></mat-checkbox>
                <div class="contract-wrapper-content">
                    <app-contract-label [contract]="contract"></app-contract-label>
                </div>
            </div>
    
        </ng-container>
        
    </div>

</div>